import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ManagementService } from '../../management.service';
import { ProgramBuilderMainService } from 'src/app/modules/creation-center/components/program-builder-main/program-builder-main.service';
import { PostHogService } from 'src/app/shared/services/posthog.service';

@Component({
	selector: 'app-access-program',
	templateUrl: './access-program.component.html',
	styleUrls: ['./access-program.component.scss']
})
export class AccessProgramComponent implements OnInit {
	blockLoader: string = "blockLoader";
	searchQuery: string = '';
	programs: any = [];
	categories: any = [];
	filteredCategories: any[] = [];
	searching: boolean = false;
	expandedPanels: Set<number> = new Set();
	orgName: string = "";

	constructor(
		private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private spinner: NgxSpinnerService,
		public dialogRef: MatDialogRef<AccessProgramComponent>,
		private organisationService: ManagementService,
		private snackbar: MatSnackBar,
		private programBuilderMainService: ProgramBuilderMainService,
		private postHogService: PostHogService
	) {
		this.orgName = this.data.name;
	}

	ngOnInit(): void {
		this.getCategories()
		// console.log('data', this.data)
	}


	getCategories() {
		this.programBuilderMainService.getCategories().subscribe(async (data: any) => {
			this.categories = data;
			//   console.log('Categories:', this.categories);
			await this.getProgramsForSubcategories();
		});
	}

	async getProgramsForSubcategories() {
		const data = await this.programBuilderMainService.getProgramsAsync();
		this.programs = data;
		this.data.hiddenPrograms = this.data.hiddenPrograms || [];
		this.data.allowedPrograms = this.data.allowedPrograms || [];

		this.categories.forEach((category: any) => {
			category.subCategories.forEach((subCategory: any) => {
				subCategory.programs = [];
			});
		});

		this.categories.forEach((category: any) => {
			category.subCategories.forEach((subCategory: any) => {
				subCategory.programs = subCategory.programs || [];

				this.programs.forEach((program: any) => {
					if (program.subCategory.id === subCategory.id) {
						subCategory.programs.push(program);
					}
				});

				subCategory.programs.sort((programA: any, programB: any) => {
					if (programA.name < programB.name) {
						return -1;
					} else if (programA.name > programB.name) {
						return 1;
					} else {
						return 0;
					}
				});
			});
		});

		//   console.log('Categories with Programs:', this.categories);
	}

	isHiddenProgram(programId: string): boolean {
		console.log('this.data.hiddenPrograms.includes(programId)', this.data.hiddenPrograms.includes(programId))
		return this.data.hiddenPrograms.includes(programId);
	}

	async toggleHiddenProgram(programId: string) {
		if (this.isHiddenProgram(programId)) {
			this.data.hiddenPrograms = this.data.hiddenPrograms.filter((id: any) => id !== programId);
		} else {
			this.data.hiddenPrograms.push(programId);
			this.data.allowedPrograms = this.data.allowedPrograms.filter((id: any) => id !== programId);
		}

		const programName = this.programs.find((p: any) => p.id === programId)?.name || '';
		const userEmail = localStorage.getItem('username');
		const role = localStorage.getItem('roleId');

		this.postHogService.capture('Show program', {
			'User email': userEmail,
			'device_type': 'Web',
			'role': role,
			'is_allow': !this.isHiddenProgram(programId),
			'organizatio_name-program_name': `${this.orgName}-${programName}`
		});

		await this.organisationService.saveOrgdata(this.data, this.data.id);
		// console.log('this.data', this.data)
	}

	isAllowedProgram(programId: string): boolean {
		return this.data.allowedPrograms.includes(programId);
	}

	async toggleAllowedProgram(programId: string, event: any) {
		let actionSuccess = false;
		if (this.isAllowedProgram(programId)) {
			this.data.allowedPrograms = this.data.allowedPrograms.filter((id: any) => id !== programId);
			await this.organisationService.saveOrgdata(this.data, this.data.id);
			actionSuccess = true;
		} else {
			if (this.isHiddenProgram(programId)) {
				this.snackbar.open("Please toggle Show Program on for this program before allowing access to it.", "OK", {
					duration: 3000
				});

				await this.getProgramsForSubcategories();
				// event.checked = false;
			} else {
				this.data.allowedPrograms.push(programId);
				// event.checked = true;
				await this.organisationService.saveOrgdata(this.data, this.data.id);
				actionSuccess = true;
			}
		}

		if (actionSuccess) {
			const programName = this.programs.find((p: any) => p.id === programId)?.name || '';
			const userEmail = localStorage.getItem('username');
			const role = localStorage.getItem('roleId');

			this.postHogService.capture('Allow access', {
				'User email': userEmail,
				'device_type': 'Web',
				'role': role,
				'is_allow': this.isAllowedProgram(programId),
				'organizatio_name-program_name': `${this.orgName}-${programName}`
			});
		}
		// console.log('this.data', this.data)
	}

	closeModal() {
		this.dialogRef.close();
	}

	searchPrograms() {
		console.log('searchQuery', this.searchQuery)
		this.categories.forEach((category: any) => {
			category.subCategories.forEach((subCategory: any) => {
				subCategory.programs = subCategory.programs.filter((program: any) =>
					program.name.toLowerCase().includes(this.searchQuery.toLowerCase())
				);
			});
		});
	}

	searchAndExpand() {
		this.filteredCategories = [];

		this.categories.forEach((category: any) => {
			const filteredCategory = { ...category, subCategories: [] };

			category.subCategories.forEach((subCategory: any) => {
				const matchingPrograms = subCategory.programs.filter((program: any) =>
					program.name.toLowerCase().includes(this.searchQuery.toLowerCase())
				);

				if (matchingPrograms.length > 0) {
					filteredCategory.subCategories.push({ ...subCategory, programs: matchingPrograms });
				}
			});

			if (filteredCategory.subCategories.length > 0) {
				this.filteredCategories.push(filteredCategory);
			}
		});

		if (this.searchQuery == '') {
			this.filteredCategories = []
		}
	}

	isPublishedFalse(program: any): boolean {
		console.log('program', program)
		return program && program.isPublished === false;
	}
}